import React, { useEffect } from 'react';
import { useImageCache } from '../hooks/useImageCache';


interface CachedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string; // Force src to be required
}

export function CachedImage({ src, alt, ...props }: CachedImageProps) {
  const { cache, loadImage } = useImageCache();

  const displaySrc = cache[src] || src;

  useEffect(() => {
    loadImage(src);
  }, [src, loadImage]);

  return <img src={displaySrc} alt={alt} {...props} />;
}
